import React, { useContext, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import ic_bell_green from "../assets/images/ic_bell_green.svg";
import ic_account_green from "../assets/images/ic_account_green.svg";
import ic_bag_green from "../assets/images/ic_bag_green.svg";
import ic_bell_light from "../assets/images/ic_bell_light.svg";
import ic_account_light from "../assets/images/ic_account_light.svg";
import ic_bag_light from "../assets/images/ic_bag_light.svg";
import ic_search_green from "../assets/images/ic_search_green.svg";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import DineInBanner from "./DineInBanner";
import { Link, useNavigate } from "react-router-dom";

import ic_ac_setting from "../assets/images/ic_ac_setting.png";
import ic_logout from "../assets/images/ic_logout.svg";
import user_img from "../assets/images/user_img.png";
import dummyProfile from "../assets/images/dummyProfile.webp";
import ic_req_ambulance from "../assets/images/ic_req_ambulance.svg";
import Logo from "../assets/images/logo-black.png";
import { simpleGetCall } from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { AppContext } from "../context/AppContext";
import { FiSearch } from "react-icons/fi";
const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  // Restaurant-switch confirmation — only shown when a QR table/area is active.
  const [showSwitchConfirm, setShowSwitchConfirm] = useState(false);
  const [pendingStore, setPendingStore] = useState(null);
  const navigate = useNavigate();

  const handleScroll = () => {
    if (window.scrollY > 20) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Auto-close mobile drawer on route changes / resize past breakpoint
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 767 && mobileNavOpen) setMobileNavOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [mobileNavOpen]);

  // Lock body scroll while drawer is open
  useEffect(() => {
    if (mobileNavOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [mobileNavOpen]);

  const {
    storesList,
    setSelectedStore,
    selectedStore,
    restaurantGeofenceRadiusKm,
    set_selected_location,
    setRestaurantGeofenceRadiusKm,
    setRestaurantDetails,
    setStoresList,
    setSearchTerm,
    searchTerm,
    selectedTable,
    setSelectedTable,
    selectedArea,
    setSelectedArea,
    clearTableSession,
  } = useContext(AppContext);

  const handleLogOut = () => {
    set_selected_location([]);
    setRestaurantDetails(null);
    setStoresList([]);
    setSelectedStore(null);
    setRestaurantGeofenceRadiusKm(6);
    // Ends the whole QR table session (table/area + resolved table + order /
    // bill-request ids); localStorage.clear() below covers the storage side.
    clearTableSession();
    localStorage.clear();

    navigate("/");
  };

  // Restaurant switching from the header dropdown. If the user arrived via a QR
  // scan (table/area set), switching restaurants means leaving that table — so
  // confirm first, then clear the table/area context on confirm.
  const applyStoreSwitch = (store) => {
    localStorage.setItem("selectedStore", store.value);
    setSelectedStore(store.value);
  };

  const handleStoreSelect = (store) => {
    if (store.value == selectedStore) return; // same restaurant — nothing to do
    if (selectedTable || selectedArea) {
      setPendingStore(store);
      setShowSwitchConfirm(true);
      return;
    }
    applyStoreSwitch(store);
  };

  const confirmStoreSwitch = () => {
    if (pendingStore) {
      applyStoreSwitch(pendingStore);
      // Left the table — drop the whole QR table session (table/area plus the
      // resolved table id and any order / bill-request ids).
      clearTableSession();
    }
    setPendingStore(null);
    setShowSwitchConfirm(false);
  };

  const cancelStoreSwitch = () => {
    setPendingStore(null);
    setShowSwitchConfirm(false);
  };

  const formattedStores =
    storesList?.length > 0
      ? storesList.map((store) => ({
          value: store.value,
          label: store.label,
          id: store.id,
        }))
      : [];

  const selectedStoreObj = storesList.find(
    (store) => store.value == selectedStore
  );
  const Data = JSON.parse(localStorage.getItem("LOGIN_DATA"));

  // following code for serviceticker working
  const [selectedStroeObject, setSelectedStoreObject] =
    useState(selectedStoreObj);
  console.log("selectedStroeObject ===>", selectedStroeObject);

  function getSelectedStore(selectedStore, storeList) {
    if (!Array.isArray(storeList) || typeof selectedStore !== "number") {
      console.error("Invalid input: expected (number, array)");
      return null;
    }

    const foundStore = storeList.find(
      (store) => store.value === selectedStore || store.id === selectedStore
    );
    return foundStore || null;
  }

  //

  // Area (capitalized) — used in the restaurant-switch confirmation modal.
  // The persistent dine-in indicator itself lives in <DineInBanner />.
  const areaLabel = selectedArea
    ? selectedArea.charAt(0).toUpperCase() + selectedArea.slice(1)
    : "";

  return (
    <div className={`cx-header-wrapper${mobileNavOpen ? " is-drawer-open" : ""}`}>
      <Modal show={showSwitchConfirm} onHide={cancelStoreSwitch} centered>
        <Modal.Body style={{ textAlign: "center", padding: "26px 22px" }}>
          <div style={{ fontSize: 34, marginBottom: 6 }} aria-hidden="true">🍽️</div>
          <h5 style={{ color: "var(--color-secondary)", fontWeight: 700, marginBottom: 10 }}>
            Change restaurant?
          </h5>
          <p style={{ color: "var(--color-gray-600)", fontSize: 14, lineHeight: 1.5, marginBottom: 22 }}>
            You're currently seated at{" "}
            <strong style={{ color: "var(--color-secondary)", textTransform: "capitalize" }}>
              {[areaLabel, selectedTable ? `Table ${selectedTable}` : null]
                .filter(Boolean)
                .join(" · ")}
            </strong>
            . Switching to{" "}
            <strong style={{ color: "var(--color-secondary)" }}>{pendingStore?.label}</strong> will
            clear your table.
          </p>
          <div style={{ display: "flex", gap: 12 }}>
            <button
              type="button"
              onClick={cancelStoreSwitch}
              style={{
                flex: 1,
                padding: "11px 0",
                borderRadius: 10,
                border: "none",
                background: "#f9bc03",
                color: "var(--color-white)",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              Keep Table
            </button>
            <button
              type="button"
              onClick={confirmStoreSwitch}
              style={{
                flex: 1,
                padding: "11px 0",
                borderRadius: 10,
                border: "1px solid var(--color-secondary)",
                background: "#fff",
                color: "var(--color-secondary)",
                fontWeight: 600,
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              Change Restaurant
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <div
        className={
          scrolled
            ? " scrollActive header-bottom-section"
            : "header-bottom-section"
        }
      >
        <div className="first">
          <div className="logo-wrapper">
            <Link to="/Home">
              <img src={Logo} alt="" />
            </Link>
            {/* <label htmlFor="">Your Logo</label> */}
          </div>
        </div>

        <button
          type="button"
          className={`header-mobile-toggle${mobileNavOpen ? " is-open" : ""}`}
          aria-label={mobileNavOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileNavOpen}
          onClick={() => setMobileNavOpen((v) => !v)}
        >
          <span />
        </button>

        {(window.location.pathname == "/Home" ||
          window.location.hash == "#/Home") && (
          <div className="second">
            <div className="search-select-wrapper">
              <Dropdown className="restaurant-dropdown">
                <Dropdown.Toggle
                  id="restaurant-dropdown-toggle"
                  aria-label="Select Restaurant"
                >
                  <span className="rd-label">
                    <span className="rd-name">
                      {storesList?.find((s) => s.value == selectedStore)?.label ||
                        "Select Restaurant"}
                    </span>
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  renderOnMount
                  popperConfig={{ strategy: "fixed" }}
                >
                  {storesList?.map((store) => {
                    const isClosed = store.store_status == 0;
                    const isOutOfArea =
                      !isClosed &&
                      parseFloat(store?.Distance?.distanceInKm)?.toFixed(2) >
                        restaurantGeofenceRadiusKm;
                    const isActive = selectedStore == store.value;
                    return (
                      <Dropdown.Item
                        key={store.id}
                        as="button"
                        active={isActive}
                        className={`rd-item${
                          isClosed ? " rd-item-closed" : ""
                        }${isOutOfArea ? " rd-item-far" : ""}`}
                        onClick={() => handleStoreSelect(store)}
                      >
                        <span className="rd-item-name">{store.label}</span>
                        {isClosed && (
                          <span className="rd-badge rd-badge-closed">
                            Closed
                          </span>
                        )}
                        {isOutOfArea && (
                          <span className="rd-badge rd-badge-far">
                            Out of area
                          </span>
                        )}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
              <div
                className="header-search-input-wrap"
                style={{ position: "relative" }}
              >
                <Form.Control
                  type="text"
                  placeholder="Search Here .."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <FiSearch
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "12px",
                    transform: "translateY(-50%)",
                    color: "#888",
                    cursor: "pointer",
                  }}
                />
              </div>
            </div>
          </div>
        )}

        <div className={`third${mobileNavOpen ? " is-open" : ""}`}>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <div className="my-ac-wrapper" id="dropdown-basic">
                {scrolled ? (
                  <img src={ic_account_green} alt="" />
                ) : (
                  <img src={ic_account_green} alt="" />
                )}

                <label htmlFor="" className="mb-0">My Account</label>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <div className="name-img-user">
                <div className="left">
                  <img
                    src={
                      JSON.parse(
                        localStorage.getItem("user_profile_img_url")
                      ) &&
                      JSON.parse(
                        localStorage.getItem("user_profile_img_url") != "null"
                      ) &&
                      JSON.parse(
                        localStorage.getItem("user_profile_img_url") !=
                          undefined
                      )
                        ? ApiConfig?.BASE_URL +
                          "/" +
                          JSON.parse(
                            localStorage.getItem("user_profile_img_url")
                          )
                        : dummyProfile
                    }
                    alt="profile"
                    onError={(e) => {
                      // e.target.onerror = null; // prevents infinite loop
                      e.target.src = { dummyProfile }; // your default image path
                    }}
                  />
                </div>
                <div className="right">
                  <label htmlFor="" className="name">
                    {Data?.first_name}
                  </label>
                  {/* <p className="animal-name">Dog ,Cat</p> */}
                </div>
              </div>
              <div className="menu">
                <Dropdown.Item as={Link} to="/ProfileSetting">
                  <img src={ic_ac_setting} />
                  Account Settings
                </Dropdown.Item>
              </div>

              <div className="menu" id="logout" onClick={handleLogOut}>
                <Link to="/">
                  <img src={ic_logout} alt="" />
                  Logout
                </Link>
              </div>
            </Dropdown.Menu>
          </Dropdown>
          <div className="nav-divider" />

          <Link to="Cart" style={{ textDecoration: "none", color: "inherit" }} onClick={() => setMobileNavOpen(false)}>
            <div className="my-blog-wrapper">
              <div className="img-badg">
                {scrolled ? (
                  <img src={ic_bag_green} alt="" />
                ) : (
                  <img src={ic_bag_green} alt="" />
                )}
              </div>
              <label className="mb-0">My Cart</label>
            </div>
          </Link>

          <div className="nav-divider" />

          <div className="bell-wrapper">
            <Link to="/Notification" onClick={() => setMobileNavOpen(false)}>
              <div className="img-badg">
                {scrolled ? (
                  <img src={ic_bell_green} alt="" />
                ) : (
                  <img src={ic_bell_green} alt="" />
                )}
              </div>
            </Link>
          </div>
        </div>
      </div>
      <DineInBanner />
    </div>
  );
};

export default Header;
